import { Text } from "@chakra-ui/react";
import { ColumnDefWithTooltip } from "src/components/Table/Table";
import { TextWithOverflowTooltip } from "src/components/TextWithOverflowTooltip";
import { GradeConfig } from "src/scenes/orgAdmin/forms/types";
import { ColumnId } from "./constants";

type Row = { form: { grade: GradeConfig | null } };
export function buildGradeColumnDef<T extends Row>(): ColumnDefWithTooltip<T> {
  return {
    accessorFn: (row) => row.form.grade?.label,
    id: ColumnId.Grade,
    header: "Apl. Grade",
    tooltip: "Sort by applying grade",
    cell: (props) => {
      const grade = props.row.original.form.grade;

      if (grade) {
        return (
          <TextWithOverflowTooltip
            content={grade.label}
            maxWidth="120px"
            minWidth="120px"
          />
        );
      }

      return (
        <Text maxWidth="120px" minWidth="120px" variant="placeholder">
          No grade
        </Text>
      );
    },
  };
}
